<template lang="pug">
	div
		page-header(:title='title')
		form(@submit.prevent='gravar')
			.modal-body
				.form-horizontal
					vue-element-loading(:active='isActive', spinner='bar-fade-scale', color='#428BCA')
					input-form-text(textInput='Título', :required='true', v-model='form.titulo', :value='form.titulo')
			footer-button(:disabled='isActive')
	</template>
	
	<script>
	import { mapGetters, mapActions } from 'vuex'
	import VueElementLoading from 'vue-element-loading'
	import PageHeader from '@/components/PageHeader'
	import InputFormText from '@/components/form/InputForm'
	import FooterButton from '@/components/form/FooterButton'
	import SelectForm from '@/components/form/SelectForm'
	import Permission from '@/mixins/Permission'
	import req from '@/components/request'
	import { sucesso, erro } from '@/components/Message'
	
	export default {
		components: {
			PageHeader,
			InputFormText,
			FooterButton,
			SelectForm,
			VueElementLoading
		},
		mixins: [Permission],
		computed: {
			...mapGetters([
				'user'
			])
		},
		data() {
			return {
				title: 'Concursos',
				form: {
					titulo: '',
				},
				isActive: false
			}
		},
		methods: {
			...mapActions([
				'getLogsTotal'
			]),
			async gravar() {
				this.isActive = true
				const body = this.form
				//this.setVersion()
				if (this.$route.params.id) {
					await req(`/v1/concursos/${this.$route.params.id}`, 'put', body).catch(response => {
						'error: ' + response
						erro()
					})
					sucesso('Atualizado...')
					this.getLogsTotal(this.user.id)
					this.$router.push('/servicos/concursos')
				} else {
					await req('/v1/concursos', 'post', body).catch(response => {
						'error: ' + response
						erro()
					})
					sucesso('Atualizado...')
					this.getLogsTotal(this.user.id)
					this.$router.push('/servicos/concursos')
				}
				this.isActive = false
			},
			async setVersion() {
				const dados = await req('/versao/1', 'put', {
					title: Date.now()
				})
				dados
			},
			async getDados() {
				const resp = await req(`/v1/concursos/${this.$route.params.id}`).catch(response => {
					'error: ' + response
					erro()
				})
				this.form.titulo = resp.titulo
				this.isActive = false
			},
			verifPermissao() {
				if (this.$route.params.id) {
					if (!this.ACTION.e) {
						this.$router.push('/erro')
					}
				} else {
					if (!this.ACTION.c) {
						this.$router.push('/erro')
					}
				}
			}
		},
		mounted() {
			this.verifPermissao()
			if (this.$route.params.id) {
				this.isActive = true
				this.getDados()
			}
		}
	}
	</script>
	
	<style lang="stylus" scoped>
	
	</style>
	